/*
 * @Author: Json Chen
 * @Date: 2021-06-23 09:35:23
 * @LastEditTime: 2021-06-25 13:30:57
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/LinkLibrary/Hooks/useEditDetailByUuid.ts
 */
import { useRequest } from 'ahooks';
import { getLinkLibraryDetail } from '@/src/request/settings/linkLibrary';
import { LinkType } from '../type';
const useEditDetailByUuid = ({ uuid }: { uuid: string }) => {
  if (!uuid) {
    return {
      initTab: LinkType.URL,
      initTitle: '',
      initAppid: '',
      initUrl: '',
      initExtra: '',
      initPath: '',
      initLanguage: '',
      initRelatedMiniProgram: null,
    };
  }

  const { data = {} } = useRequest(() => {
    return getLinkLibraryDetail(uuid);
  });

  return {
    initTab: data.category || LinkType.URL,
    initTitle: data.title || '',
    initAppid: data.appID || '',
    initPath: data.path || '',
    initUrl: data.url || '',
    initExtra: data.extraData || '',
    initLanguage: data.language || '',
    initRelatedMiniProgram: data.relatedMiniProgram || null,
  };
};

export default useEditDetailByUuid;
